import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { useArrayFieldItemApi } from 'informed';
import { Button } from '@tesla/design-system-react';

var _excluded = ["text"];
var RemoveButton = function RemoveButton(props) {
  var _useArrayFieldItemApi = useArrayFieldItemApi(),
    remove = _useArrayFieldItemApi.remove;
  var text = props.text,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(Button, _extends({
    type: "button",
    onClick: remove
  }, rest), text !== null && text !== void 0 ? text : 'Remove');
};

export { RemoveButton };
